import React, { useContext } from "react";
import classNames from "classnames";
import { QuestionContent } from "../QuestionContent";
import { QuestionContext } from "../../context";

export function QuestionMixed({ className, children, style }: RenderComponent) {
    const ctx = useContext(QuestionContext);

    if (ctx.type !== "Mixed") throw new Error("error type data");

    if (!ctx.renderSubQuestion)
        throw new Error("property renderSubQuestion needed!");

    return (
        <div className={classNames("QuestionMixed", className)} style={style}>
            <QuestionContent />

            {ctx.data.questions.map((item, index) => (
                <React.Fragment key={item.topicId}>
                    {ctx.renderSubQuestion(index, item)}
                </React.Fragment>
            ))}

            {children}
        </div>
    );
}
